import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'

const AutoCompleteFilterInput = ({
  filter,
  options,
  selectedValues,
  handleSelectedValues,
  filterWidthClass,
  ...props
}) => {
  const sanitizeDefaultValue = (val) => (Array.isArray(val) ? val : [val])

  const [value, setValue] = useState(sanitizeDefaultValue(selectedValues[filter.field] || []))

  useEffect(() => {
    const sanitized = sanitizeDefaultValue(selectedValues[filter.field] || [])
    if (JSON.stringify(value) !== JSON.stringify(sanitized)) {
      setValue(sanitized)
    }
  }, [selectedValues, filter.field])

  let safeOptions = options[filter.field]
    ? options[filter.field].map((option) => (option === null ? 'null' : option))
    : []
  safeOptions = [
    ...safeOptions,
    ...(options[filter.field] ? options[filter.field].map((option) => '!' + (option === null ? 'null' : option)) : []),
  ]

  return (
    <Autocomplete
      multiple
      options={safeOptions}
      getOptionLabel={(option) => option.toString()}
      isOptionEqualToValue={(option, value) => option === value}
      name={filter.field}
      className={filterWidthClass}
      value={value ? value : []}
      onChange={(event, newValue, reason) => {
        handleSelectedValues(event, { [filter.field]: newValue }, reason)
        if (reason === 'clear') setValue([])
        setValue(newValue)
      }}
      renderInput={(params) => (
        // <Tooltip title="Select the values you want to filter. Negative filter values start with !">
        <TextField label={filter.headerName} name={'x' + filter.field} variant="outlined" {...params} />
        // </Tooltip>
      )}
      {...props}
    />
  )
}

AutoCompleteFilterInput.propTypes = {
  filter: PropTypes.object,
  filterWidthClass: PropTypes.string,
  options: PropTypes.object,
  selectedValues: PropTypes.object,
  handleSelectedValues: PropTypes.func,
}

export default AutoCompleteFilterInput
